export default "__VITE_ASSET__hmv91dCj__"